module.exports = __webpack_public_path__ + "img/1board_logo.ff2be3d8.png";